import * as Saxes from 'saxes'
import { BATCH_SIZE } from '../constants'

const ATTR = '$'

export class XmlParser { // Note: also in backend for end2end tests
  parser: Saxes.SaxesParser
  nodes: any[] = []
  rootNode: object = {}
  withinParentNode: boolean = false
  nodeName: string
  parentNodeName: string
  amountAttribute: string
  excludedNodeName: string
  rootNodeName: string
  streamReader: ReadableStreamDefaultReader
  totalNodes: number = -1
  lastTagName: string
  closed: boolean = false
  endedWithError: boolean = false

  skipAddingNodes: boolean = false

  firstChunk: string

  openTags: any[] = []

  get lastTag() {
    return this.openTags[this.openTags.length - 1]
  }

  constructor(readStream: ReadableStream) {
    this.streamReader = readStream.getReader()

    this.parser = new Saxes.SaxesParser({})

    this.parser.onopentag = (tag) => {
      if (!this.rootNodeName) this.rootNodeName = tag.name

      if (this.totalNodes === -1 && this.amountAttribute && tag.name === this.parentNodeName) {
        this.totalNodes = parseInt(tag.attributes[this.amountAttribute].toString(), 10)
      }

      if (tag.name === this.excludedNodeName) {
        this.skipAddingNodes = true
      }

      if (this.skipAddingNodes) return

      if (!this.parentNodeName || this.withinParentNode) {
        if ((!this.nodeName || tag.name === this.nodeName) && !this.lastTag) {
          const node: any = {}

          for (const key in tag.attributes) {
            if (!node[ATTR]) node[ATTR] = {}

            node[ATTR][key] = tag.attributes[key]
          }

          this.nodes.push(node)

          this.openTags.push(node)
        } else {
          if (!this.lastTag[tag.name]) this.lastTag[tag.name] = []

          const node: any = {}

          for (const key in tag.attributes) {
            if (!node[ATTR]) node[ATTR] = {}

            node[ATTR][key] = tag.attributes[key]
          }

          this.lastTag[tag.name].push(node)

          this.openTags.push(node)
        }

        this.lastTagName = tag.name
      }

      if (tag.name === this.parentNodeName || !this.parentNodeName) {
        this.withinParentNode = true
      }
    }

    this.parser.onclosetag = (tag) => {
      if (this.skipAddingNodes) {
        if (tag.name === this.excludedNodeName) {
          this.skipAddingNodes = false
        }
      } else {
        this.openTags.splice(this.openTags.length - 1, 1)

        if (tag.name === this.parentNodeName) this.withinParentNode = false
      }
    }

    this.parser.ontext = (tag) => {
      const trimmed = tag.trim()

      if (trimmed) {
        try {
          this.openTags[this.openTags.length - 2][this.lastTagName] = trimmed
        } catch (error) {
          console.error(error)

          if (!this.endedWithError) {
            window.alert('An error ocurred while reading your library file. Please try exporting it again because this file may be broken.')
          }

          this.endedWithError = true
        }
      }
    }

    this.parser.onerror = (error) => {
      console.log(error)
    }
  }

  async parseFirstChunk() {
    // Get first chunk before starting so we can read it and determine which type of DVS it comes from
    const { value }: { value: Uint8Array } = await this.streamReader.read()

    this.firstChunk = new TextDecoder().decode(value)
  }

  async getNodeBatch(): Promise<any[]> {
    let doneReading: boolean = false

    while (!doneReading && this.nodes.length <= BATCH_SIZE) { // Must be <= otherwise it can happen that the chunk stops in the middle of a node and that partial node will be sent to the server
      let s: string = ''
      if (!this.firstChunk) {
        const readResult: { done: boolean, value: Uint8Array } = await this.streamReader.read()

        doneReading = readResult.done

        if (!doneReading) {
          s = new TextDecoder().decode(readResult.value)
        }
      } else {
        s = this.firstChunk

        this.firstChunk = ''
      }

      if (!doneReading) {
        this.parser.write(s)
      }
    }

    if (doneReading) {
      this.parser.close()
      this.streamReader.releaseLock()

      this.closed = true

      if (this.openTags.length > 0) throw new Error('expected there to be zero open tags')
    }

    return this.nodes.splice(0, BATCH_SIZE)
  }

  setNodeParameters(nodeName: string, parentNodeName: string, amountAttribute?: string) {
    if (this.nodes.length !== 0) throw new Error('expected nodes to be empty')

    this.nodeName = nodeName
    this.parentNodeName = parentNodeName

    if (amountAttribute) {
      this.amountAttribute = amountAttribute
    }
  }

  setExcludedNode(nodeName: string) {
    this.excludedNodeName = nodeName
  }
}
